import React from 'react';
import {__RouterContext} from 'react-router';

/** Created an abstraction since the API for __RouterContext might change in future */

export default function useRouter () {
  return React.useContext(__RouterContext);
}